<template>
  <div>
    <create-content-layout :title="'ویرایش درس'" :submitFunction="UpdateContent"></create-content-layout>
  </div>
</template>
<script>
import CreateContentLayout from "./CreateLayoutForLesson";
import {mapActions} from 'vuex';

export default {
  name: "CreateContent",
  components: {CreateContentLayout},
  methods: {
    ...mapActions({
      UpdateContent: "Content/updateContent"
    })
  }
}
</script>